import { capitalGainsTax } from "../../engine/calculations";
import { TAX_NOTICE } from "../../lib/taxConfig";

const config = {
  key: "capital-gains-tax",
  title: "Capital Gains Tax",
  category: "Tax",
  description: "Estimate the capital gains tax on selling an asset, based on asset class and holding period.",
  notice: TAX_NOTICE,
  fields: [
    {
      key: "assetClass",
      label: "Asset class",
      type: "select",
      default: "equity",
      options: [
        { value: "equity", label: "Equity (shares / equity mutual funds)" },
        { value: "debt_fund", label: "Debt mutual fund" },
        { value: "property", label: "Property" },
        { value: "other", label: "Other (gold, unlisted shares, etc.)" },
      ],
    },
    { key: "purchaseValue", label: "Purchase value", type: "currency", default: 5_00_000, min: 0, max: 10_00_00_000 },
    { key: "saleValue", label: "Sale value", type: "currency", default: 8_00_000, min: 0, max: 10_00_00_000 },
    { key: "purchaseDate", label: "Purchase date (YYYY-MM-DD)", type: "text", default: "2022-01-01" },
    { key: "holdingMonths", label: "Holding period (months)", type: "number", default: 36, min: 0, max: 600 },
    { key: "slabRatePct", label: "Your income tax slab rate", type: "percent", default: 30, min: 0, max: 42.74 },
    {
      key: "ltcgExemptionAlreadyUsed",
      label: "Equity LTCG exemption already used this FY",
      type: "currency",
      default: 0,
      min: 0,
      max: 1_25_000,
      help: "Only applies to equity — the first Rs 1.25 lakh of equity LTCG per financial year is tax-free.",
    },
  ],
  compute(values) {
    const assetClass = values.assetClass || "equity";
    const purchaseValue = Number(values.purchaseValue) || 0;
    const saleValue = Number(values.saleValue) || 0;
    const purchaseDate = values.purchaseDate || "2022-01-01";
    const holdingMonths = Number(values.holdingMonths) || 0;
    const slabRatePct = Number(values.slabRatePct) || 0;
    const ltcgExemptionAlreadyUsed = Number(values.ltcgExemptionAlreadyUsed) || 0;

    const result = capitalGainsTax(assetClass, purchaseValue, saleValue, holdingMonths, purchaseDate, slabRatePct, ltcgExemptionAlreadyUsed);

    return {
      headline: { label: "Estimated tax payable", value: result.tax },
      extraHeadlines: [{ label: "Net proceeds after tax", value: result.netProceeds }],
      breakdown: [
        { label: "Capital gain", value: result.gain },
        { label: "Holding treated as", value: result.isLongTerm ? "Long-term" : "Short-term", format: "text" },
      ],
    };
  },
};

export default config;
